/**
 * Article editorial layout: split content by images into alternating rows.
 * Reads from #article-editorial-source, writes to #article-editorial-output.
 * Handles mixed content e.g. <p><img><br><br>text</p> by splitting into image + text.
 * Ignores empty <img> tags (no src or empty src); only uses images with content.
 * Pairs text blocks with image blocks (zip); extra text block becomes centered.
 */
(function () {
  var src = document.getElementById('article-editorial-source');
  var out = document.getElementById('article-editorial-output');
  if (!src || !out) return;

  function isValidImg(img) {
    if (!img || img.tagName !== 'IMG') return false;
    var s = img.getAttribute('src');
    return typeof s === 'string' && s.trim().length > 0;
  }

  function findFirstValidImg(container) {
    if (!container || !container.querySelectorAll) return null;
    var imgs = container.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (isValidImg(imgs[i])) return imgs[i];
    }
    return null;
  }

  var sequence = [];
  var children = Array.prototype.slice.call(src.children);

  for (var c = 0; c < children.length; c++) {
    var child = children[c];

    if (child.tagName === 'IMG') {
      if (isValidImg(child)) {
        sequence.push({ type: 'image', el: child.cloneNode(true) });
      }
      continue;
    }

    var imgs = child.querySelectorAll ? child.querySelectorAll('img') : [];
    var hasValidImg = findFirstValidImg(child) !== null;

    if (!hasValidImg) {
      sequence.push({ type: 'text', el: child.cloneNode(true) });
      continue;
    }

    var nodes = Array.prototype.slice.call(child.childNodes);
    var textBuf = [];
    var skipBr = false;

    for (var n = 0; n < nodes.length; n++) {
      var node = nodes[n];
      var nodeIsImg = false;
      var imgEl = null;

      if (node.nodeType === 1) {
        if (node.tagName === 'IMG') {
          if (isValidImg(node)) {
            nodeIsImg = true;
            imgEl = node;
          }
        } else if (node.querySelector && node.querySelector('img')) {
          imgEl = findFirstValidImg(node);
          if (imgEl) nodeIsImg = true;
        }
      }

      if (nodeIsImg) {
        if (textBuf.length > 0) {
          var wrap = document.createElement(child.tagName);
          for (var tb = 0; tb < textBuf.length; tb++) {
            wrap.appendChild(textBuf[tb].cloneNode(true));
          }
          if (wrap.textContent.replace(/[\s\u00A0]/g, '').length > 0) {
            sequence.push({ type: 'text', el: wrap });
          }
          textBuf = [];
        }
        sequence.push({ type: 'image', el: imgEl.cloneNode(true) });
        skipBr = true;
      } else if (skipBr && node.nodeType === 1 && node.tagName === 'BR') {
        /* skip <br> immediately after image */
      } else {
        skipBr = false;
        if (node.nodeType === 1 && node.tagName === 'IMG' && !isValidImg(node)) {
          /* skip empty img nodes */
        } else {
          textBuf.push(node);
        }
      }
    }

    if (textBuf.length > 0) {
      var wrap = document.createElement(child.tagName);
      for (var tb = 0; tb < textBuf.length; tb++) {
        wrap.appendChild(textBuf[tb].cloneNode(true));
      }
      if (wrap.textContent.replace(/[\s\u00A0]/g, '').length > 0) {
        sequence.push({ type: 'text', el: wrap });
      }
    }
  }

  var blocks = [];
  var curText = null;
  for (var s = 0; s < sequence.length; s++) {
    if (sequence[s].type === 'image') {
      if (curText) {
        blocks.push(curText);
        curText = null;
      }
      blocks.push({ type: 'image', el: sequence[s].el });
    } else {
      if (!curText) curText = { type: 'text', els: [] };
      curText.els.push(sequence[s].el);
    }
  }
  if (curText) blocks.push(curText);

  var textBlocks = [];
  var imageBlocks = [];
  for (var b = 0; b < blocks.length; b++) {
    if (blocks[b].type === 'text') textBlocks.push(blocks[b]);
    else imageBlocks.push(blocks[b]);
  }

  var trailing = null;
  var pairCount = imageBlocks.length;
  if (textBlocks.length > imageBlocks.length) {
    trailing = textBlocks[textBlocks.length - 1];
    pairCount = Math.min(textBlocks.length - 1, imageBlocks.length);
  }

  var rows = [];
  for (var r = 0; r < pairCount; r++) {
    rows.push({
      text: textBlocks[r],
      image: imageBlocks[r],
      reverse: r % 2 === 1
    });
  }

  if (rows.length === 0 && !trailing) return;

  var frag = document.createDocumentFragment();
  for (var r = 0; r < rows.length; r++) {
    var row = rows[r];
    var div = document.createElement('div');
    div.className = 'article-editorial-row' + (row.reverse ? ' article-editorial-row--reverse' : '');

    var imgCol = document.createElement('div');
    imgCol.className = 'article-editorial-row__image';
    imgCol.appendChild(row.image.el);

    var txtCol = document.createElement('div');
    txtCol.className = 'article-editorial-row__text';
    for (var t = 0; t < row.text.els.length; t++) {
      txtCol.appendChild(row.text.els[t]);
    }

    div.appendChild(imgCol);
    div.appendChild(txtCol);
    frag.appendChild(div);
  }

  if (trailing) {
    var cDiv = document.createElement('div');
    cDiv.className = 'article-editorial-row article-editorial-row--centered';
    var cTxt = document.createElement('div');
    cTxt.className = 'article-editorial-row__text article-editorial-row__text--center';
    for (var t = 0; t < trailing.els.length; t++) {
      cTxt.appendChild(trailing.els[t]);
    }
    cDiv.appendChild(cTxt);
    frag.appendChild(cDiv);
  }

  out.appendChild(frag);
})();
